
jQuery(document).ready(function ($) {
  // --- Initialize AOS (Animate On Scroll)
  AOS.init({
    duration: 700,
    anchorPlacement: "center-bottom",
    once: true,
  });

  // --- Re-init on window resize
  $(window).on("resize", function () {
    setTimeout(() => {
      AOS.refresh();
    }, 500);
  });
});

// START HOME SERVICE SLIDER

jQuery(document).ready(function ($) {
  /* SLICK SLIDER */
  // 1. Helper: wheel + keyboard for a Slick instance
  function enableSlickWheelAndKeys($slider, opts = {}) {
    const axis = opts.axis || 'horizontal';
    const onlyWhenHovered = opts.onlyWhenHovered !== false; // default true

    // ⬇️ Make the slider “contain” horizontal overscroll so history swipe won't fire
    const el = $slider.get(0);
    if (el && el.style) {
      // contain on the slider itself
      el.style.overscrollBehaviorX = 'contain';
      // optional: belt & suspenders – stop page-level x-overscroll
      document.documentElement.style.overscrollBehaviorX = 'none';
      document.body.style.overscrollBehaviorX = 'none';
    }

    // --- Keyboard (Left/Right/Space/PageUp/Down/Home/End) ---
    function onKeydown(e) {
      const t = e.target;
      const tag = (t.tagName || '').toLowerCase();
      if (/(input|textarea|select)/.test(tag) || t.isContentEditable) return;

      const el = $slider.get(0);
      if (!el || !document.body.contains(el)) return;

      if (onlyWhenHovered) {
        const r = el.getBoundingClientRect();
        const x = (e.clientX ?? -1), y = (e.clientY ?? -1);
        const hovered = x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
        if (!hovered && !el.contains(document.activeElement)) return;
      }

      let handled = false;
      switch (e.key) {
        case 'ArrowRight': $slider.slick('slickNext'); handled = true; break;
        case 'ArrowLeft': $slider.slick('slickPrev'); handled = true; break;
        case ' ':
        case 'Spacebar':
        case 'PageDown': $slider.slick('slickNext'); handled = true; break;
        case 'PageUp': $slider.slick('slickPrev'); handled = true; break;
        case 'Home': $slider.slick('slickGoTo', 0); handled = true; break;
        case 'End': {
          const last = ($slider.slick('getSlick')?.slideCount || 1) - 1;
          $slider.slick('slickGoTo', Math.max(0, last));
          handled = true;
        } break;
      }
      if (handled) e.preventDefault();
    }

    // --- Wheel/trackpad ---
    let wheelLock = false;
    const WHEEL_LOCK_MS = 360;
    const INTENT_THRESHOLD = 6;

    function directionFromWheel(e) {
      const { deltaX = 0, deltaY = 0 } = e;
      if (axis === 'horizontal') {
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) >= INTENT_THRESHOLD) {
          return deltaX > 0 ? 1 : -1;
        }
        return 0;
      } else {
        if (Math.abs(deltaY) >= INTENT_THRESHOLD) return deltaY > 0 ? 1 : -1;
        return 0;
      }
    }

    function isHovering(el, evt) {
      if (!onlyWhenHovered) return true;
      const r = el.getBoundingClientRect();
      const { clientX: x, clientY: y } = evt;
      return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
    }

    function onWheel(e) {
      const el = $slider.get(0);
      if (!el) return;
      if (!isHovering(el, e)) return;

      const dir = directionFromWheel(e);
      if (!dir) return;

      // ⬇️ eat the gesture so it can’t bubble into “back/forward”
      e.stopImmediatePropagation();
      e.preventDefault();

      if (wheelLock) return;
      wheelLock = true;
      dir > 0 ? $slider.slick('slickNext') : $slider.slick('slickPrev');
      setTimeout(() => (wheelLock = false), WHEEL_LOCK_MS);
    }

    document.addEventListener('keydown', onKeydown, true);
    el?.addEventListener('wheel', onWheel, { passive: false });

    const dispose = () => {
      document.removeEventListener('keydown', onKeydown, true);
      el?.removeEventListener('wheel', onWheel, { passive: false });
    };
    $slider.data('slickWheelDispose', dispose);
    return dispose;
  }

  function swiperCoverFlowSlider() {
    const contentEl = document.querySelector(".swiper.js_swiper__beers-content");
    const imageEl = document.querySelector(".swiper.js_swiper__beers-image");

    if (!contentEl || !imageEl) return;
    if (imageEl.swiper) {
      imageEl.swiper.update();
      return;
    }

    const startIndex = 1;
    const root = imageEl.closest(".ha_beers__slider") || imageEl.parentElement;
    const nextEl = root.querySelector(".ha_swiper__arrow--next");
    const prevEl = root.querySelector(".ha_swiper__arrow--prev");
    const paginationEl = root.querySelector(".ha_swiper__pagination-beers");
    const isDesktop = window.matchMedia("(min-width: 750px)").matches;

    const contentSwiper = new Swiper(contentEl, {
      loop: true,
      initialSlide: startIndex,
      speed: 500,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      allowTouchMove: false,
    });

    // Flat slide (not coverflow): Safari hides coverflow slides with z-index < 0.
    // Visual “coverflow” is already done in CSS (scale / opacity on picture).
    const imageSwiper = new Swiper(imageEl, {
      loop: true,
      initialSlide: startIndex,
      speed: 500,
      grabCursor: true,
      centeredSlides: true,
      // Mobile: 2 + centered = full center + half left/right
      slidesPerView: isDesktop ? 5 : 2,
      watchSlidesProgress: true,

      navigation: {
        nextEl,
        prevEl,
      },

      pagination: paginationEl
        ? {
          el: paginationEl,
          bulletClass: "ha_swiper__bullet",
          bulletActiveClass: "is-active",
          bulletElement: "button",
          clickable: true,
        }
        : undefined,

      keyboard: {
        enabled: true,
      },

      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
        thresholdDelta: 12,
        thresholdTime: 200,
        sensitivity: 1,
      },

      breakpoints: {
        750: {
          slidesPerView: 5,
        },
      },

      on: {
        init: function () {
          contentSwiper.slideToLoop(this.realIndex, 0);
          requestAnimationFrame(() => this.update());
        },
        slideChange: function () {
          contentSwiper.slideToLoop(this.realIndex, 500);
        },
      },
    });
  }


  function autoWidthSlider(scope = document) {
    const $sliders = $(scope).find('.js_slider_auto_width');

    $sliders.each(function () {
      const $el = $(this);

      if ($el.hasClass('slick-initialized')) return;

      const $wrap = $el.closest('section');
      const $dots = $wrap.find('.ha_slick__pagination').first();

      $el.slick({
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        appendDots: $dots,
        customPaging: function (slider, i) {
          return `
          <button type="button" class="ha_dot" data-index="${i}">
            <span class="ha_dot__inner"></span>
          </button>
        `;
        },
        swipe: true,
        draggable: true,
        touchMove: true,
        touchThreshold: 10
      });

      if (typeof enableSlickWheelAndKeys === 'function') {
        enableSlickWheelAndKeys($el, { axis: 'horizontal', onlyWhenHovered: true });
      }
    });
  }

  function initRelatedProductsSlider() {
    let tries = 0;
    const maxTries = 40;

    const timer = setInterval(function () {
      const $recommendations = $('product-recommendations');
      const $slider = $recommendations.find('.js_slider_auto_width');

      console.log('checking recommendations...', {
        recommendations: $recommendations.length,
        sliders: $slider.length,
        tries: tries
      });

      if ($slider.length) {
        clearInterval(timer);
        autoWidthSlider($recommendations[0]);
      }

      tries += 1;

      if (tries >= maxTries) {
        clearInterval(timer);
        console.log('slider not found after waiting');
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRelatedProductsSlider);
  } else {
    initRelatedProductsSlider();
  }

  function swiperSlider() {
    const isMobile = window.innerWidth < 768;
    if (!isMobile) return;
    const contentSwiperElement = document.querySelector(".swiper.js_swiper__content");
    const imageSwiperElement = document.querySelector(".swiper.js_swiper__image");

    if (contentSwiperElement && imageSwiperElement) {
      // Prevent stacking instances on resize (mobile URL bar / orientation)
      if (contentSwiperElement.swiper || imageSwiperElement.swiper) return;

      // Navigation only on imageSwiper — both listening to the same arrows
      // plus controller sync caused a 2-slide jump per click.
      const contentSwiper = new Swiper(".swiper.js_swiper__content", {
        loop: true,
        grabCursor: true,
        initialSlide: 2,
        speed: 500,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          thresholdDelta: 12,
          thresholdTime: 200,
          sensitivity: 1,
        },
      });

      const imageSwiper = new Swiper(".swiper.js_swiper__image", {
        loop: true,
        effect: "cards",
        cardsEffect: {
          rotate: true,
        },
        grabCursor: true,
        initialSlide: 2,
        speed: 500,
        navigation: {
          nextEl: ".ha_swiper__arrow--next",
          prevEl: ".ha_swiper__arrow--prev",
        },
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          thresholdDelta: 12,
          thresholdTime: 200,
          sensitivity: 1,
        },
        pagination: {
          el: ".ha_swiper__pagination",
          bulletClass: "ha_swiper__bullet",
          bulletActiveClass: "is-active",
          bulletElement: "button",
          clickable: true,
        },

        on: {
          afterInit: function () {
            $(".ha_current-slide").text(this.realIndex + 1);
            setTimeout(() => {
              activateBgText();
            }, 100);
          },
          slideChangeTransitionStart: function () {
            $(".js_swiper__content .ha_featured-events__item").removeClass("is-active");
          },
          slideChangeTransitionEnd: function () {
            setTimeout(() => {
              activateBgText();
            }, 300);
          },
          slideChange: function () {
            $(".ha_current-slide").text(this.realIndex + 1);
          },
        },
      });

      imageSwiper.controller.control = contentSwiper;
      contentSwiper.controller.control = imageSwiper;

      function activateBgText() {
        $(".js_swiper__content .ha_featured-events__item").removeClass("is-active");
        const $active = $(
          ".js_swiper__content .swiper-slide.swiper-slide-active .ha_featured-events__item"
        );
        if ($active.length) {
          void $active[0].offsetWidth; // restart CSS anim
          $active.addClass("is-active");
        }
      }
    }
  }

  function stackSwiperSlider() {
    const imageSwiperElement = document.querySelector(".swiper.js_stack_swiper__image");
    if (imageSwiperElement) {
      new Swiper(".swiper.js_stack_swiper__image", {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        grabCursor: true,
        // initialSlide: 3,
        speed: 500,
        loop: true,
        autoplay: {
          delay: 200,
          disableOnInteraction: false, // keep autoplay after user swipe
        },
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          thresholdDelta: 12,
          thresholdTime: 200,
          sensitivity: 1,
        }
      });
    }
  }

  function initGSAPMarquee() {
    if (!window.gsap) return;

    document.querySelectorAll(".gsap_marquee_slider").forEach((marquee) => {
      const track = marquee.querySelector(".ha_marquee__track");
      if (!track) return;

      // kill old tween
      if (track._tween) track._tween.kill();

      // remove old hover handlers if they exist
      if (track._onEnter) marquee.removeEventListener("mouseenter", track._onEnter);
      if (track._onLeave) marquee.removeEventListener("mouseleave", track._onLeave);

      // restore original markup
      if (!track.dataset.original) track.dataset.original = track.innerHTML;
      track.innerHTML = track.dataset.original;

      gsap.set(track, { x: 0 });

      // wrap original items into one set
      const set = document.createElement("div");
      set.className = "ha_marquee__set";

      while (track.firstChild) {
        set.appendChild(track.firstChild);
      }
      track.appendChild(set);

      const makeClone = () => {
        const clone = set.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        track.appendChild(clone);
      };

      // first clone
      makeClone();

      const ensureEnough = () => {
        const marqueeW = marquee.clientWidth;
        const setW = set.getBoundingClientRect().width;
        if (!setW) return null;

        while (track.getBoundingClientRect().width < marqueeW + setW * 2) {
          makeClone();
        }

        return setW;
      };

      const setWidth = ensureEnough();
      if (!setWidth) return;

      const isReverse = marquee.classList.contains("gsap_marquee_slider--reverse");

      // 30% slower than 120
      let speed = 84;

      // make large screens a bit slower so it feels more consistent
      if (window.innerWidth >= 1600) {
        speed = 72;
      } else if (window.innerWidth >= 1200) {
        speed = 78;
      } else if (window.innerWidth >= 768) {
        speed = 84;
      } else {
        speed = 60;
      }

      const duration = setWidth / speed;

      if (isReverse) {
        gsap.set(track, { x: -setWidth });
      }

      const tween = gsap.to(track, {
        x: isReverse ? 0 : -setWidth,
        duration: duration,
        ease: "none",
        repeat: -1,
        modifiers: {
          x: (x) => `${gsap.utils.wrap(-setWidth, 0, parseFloat(x))}px`
        }
      });

      track._tween = tween;

      track._onEnter = () => tween.pause();
      track._onLeave = () => tween.resume();

      marquee.addEventListener("mouseenter", track._onEnter);
      marquee.addEventListener("mouseleave", track._onLeave);
    });
  }

  window.addEventListener("load", initGSAPMarquee);
  window.addEventListener("resize", initGSAPMarquee);

  // run after fonts/assets settle (SVG inline + webfont can change widths)
  window.addEventListener("load", () => {
    initGSAPMarquee();
    // also re-run once after a short tick to be safe
    setTimeout(initGSAPMarquee, 200);
  });

  window.addEventListener("resize", () => {
    initGSAPMarquee();
  });

  function autoWidthMobileOnlySlider() {
    const slider = $(".js_slider_auto_width_mobile_only");
    if (window.innerWidth <= 768) {
      if (!slider.hasClass("slick-initialized")) {
        slider.slick({
          variableWidth: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: true,
          swipe: true,
          draggable: true,
          touchMove: true,
          touchThreshold: 10
        });
      }
    } else {
      // Destroy slick if initialized on larger screens
      if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");
      }
    }
  }

  function getStartedMobileOnlySlider() {
    const slider = $(".js_slider_one_mobile_only");
    if (window.innerWidth <= 768) {
      if (!slider.hasClass("slick-initialized")) {
        slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: true,
          adaptiveHeight: true,
          //       appendDots: $('.ha_home_events__dots'),
          //       customPaging: function (slider, i) {
          //         return `
          //   <button class="ha_dot" data-index="${i}">
          //     <span class="ha_dot__inner"></span>
          //   </button>
          // `;
          //       },
        });
      }
    } else {
      // Destroy slick if initialized on larger screens
      if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");
      }
    }
  }
  function initAllSliders() {
    if ($(".js_slider_auto_width").length) autoWidthSlider();
    if ($(".js_coverflow_slider").length) coverflowSlider();
    if ($(".gsap_marquee_slider").length) initGSAPMarquee();
    if ($(".js_slider_auto_width_mobile_only").length) autoWidthMobileOnlySlider();
    if ($(".js_slider_one_mobile_only").length) getStartedMobileOnlySlider();
    // if ($(".js_stack__swiper").length) stackCardSwiper();

    if ($(".js_swiper__image").length) swiperSlider();
    if ($(".js_swiper__beers-image").length) swiperCoverFlowSlider();
    if ($(".js_stack_swiper__image").length) stackSwiperSlider();
  }
  window.addEventListener("load", initAllSliders);
  window.addEventListener("resize", initAllSliders);
});


jQuery(function ($) {
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  //// GSAP IMAGES FLOATING ANIMATION FOOD SHOWCASE SECTION
  function initFoodShowcaseImages() {
    const section = document.querySelector(".ha_food-showcase");
    if (!section) return;
    const leftItems = section.querySelectorAll(".ha_food-showcase__item--left");
    const rightItems = section.querySelectorAll(".ha_food-showcase__item--right");

    if (leftItems.length) {
      gsap.to(leftItems, {
        y: -80,
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top bottom",
          end: "bottom top",
          scrub: 1,
        }
      });
    }

    if (rightItems.length) {
      gsap.to(rightItems, {
        y: 80,
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top bottom",
          end: "bottom top",
          scrub: 1,
        }
      });
    }
  }
  initFoodShowcaseImages();

  function initFoodShowcaseText() {
    const section = document.querySelector('.ha_food-showcase');
    const textWrap = section?.querySelector('.ha_food-showcase__texts');
    if (!section || !textWrap) return;

    const textLines = textWrap.querySelectorAll('.ha_food-showcase__text');
    if (!textLines.length) return;

    // optional: set initial offset so it already "bleeds" off screen
    gsap.set(textLines, {
      xPercent: -10,
    });

    textLines.forEach((line, index) => {
      const direction = index % 2 === 0 ? 1 : -1; // alternate directions

      gsap.to(line, {
        xPercent: direction * 20,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      });
    });
  }

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    initFoodShowcaseText();
  }
  // GSAP DRAW LINES

  function initGridDraw(section) {
    if (!section) return;

    const svg = section.querySelector(".ha_lines");
    if (!svg) return;

    const w = Math.round(section.getBoundingClientRect().width);
    const h = Math.round(section.scrollHeight);

    if (!w || !h) return;

    const cell = window.innerWidth > 990 ? 155 : 90;
    const cols = Math.ceil(w / cell);
    const rows = Math.ceil(h / cell);

    svg.setAttribute("viewBox", `0 0 ${w} ${h}`);
    svg.setAttribute("width", w);
    svg.setAttribute("height", h);
    svg.style.width = "100%";
    svg.style.height = `${h}px`;

    const currentKey = `${w}-${h}-${cell}`;
    if (svg.dataset.gridKey === currentKey) return;
    svg.dataset.gridKey = currentKey;

    svg.innerHTML = "";

    const ns = "http://www.w3.org/2000/svg";

    for (let i = 0; i <= cols; i++) {
      const x = i * cell;
      const path = document.createElementNS(ns, "path");
      path.setAttribute("d", `M ${x} 0 V ${h}`);
      path.setAttribute("stroke", "black");
      path.setAttribute("stroke-width", "0.5");
      path.setAttribute("fill", "none");
      svg.appendChild(path);
    }

    for (let i = 0; i <= rows; i++) {
      const y = i * cell;
      const path = document.createElementNS(ns, "path");
      path.setAttribute("d", `M 0 ${y} H ${w}`);
      path.setAttribute("stroke", "black");
      path.setAttribute("stroke-width", "0.5");
      path.setAttribute("fill", "none");
      svg.appendChild(path);
    }
  }

  function setupGridWatch() {
    const sections = document.querySelectorAll("section:has(.ha_lines)");

    sections.forEach((section) => {
      let rafId = null;

      const redraw = () => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          initGridDraw(section);
        });
      };

      const ro = new ResizeObserver(() => {
        redraw();
      });

      ro.observe(section);

      redraw();
    });

    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        sections.forEach((section) => initGridDraw(section));
      }, 150);
    });
  }

  window.addEventListener("load", setupGridWatch);

});


// SORT + FILTER
jQuery(document).ready(function ($) {
  const $filterBtn = $('.js_ha_toogle');
  const $filterBody = $('.ha_b_filter_body');

  $filterBtn.on('click', function (e) {
    e.stopPropagation(); // Prevent the toggle from triggering the outside click

    const isActive = $filterBody.hasClass('is-active');
    $filterBody.toggleClass('is-active');

    $filterBody.find('details').each(function () {
      const $details = $(this);
      const $summary = $details.find('summary');

      if (isActive) {
        $details.removeAttr('open');
        $summary.removeClass('is-open');
      } else {
        $details.attr('open', true);
        $summary.addClass('is-open');
      }
    });
  });

  // Close on outside click
  $(document).on('click', function (e) {
    if (
      $filterBody.hasClass('is-active') &&
      !$filterBody.is(e.target) &&
      $filterBody.has(e.target).length === 0 &&
      !$filterBtn.is(e.target) &&
      $filterBtn.has(e.target).length === 0
    ) {
      $filterBody.removeClass('is-active');

      $filterBody.find('details').each(function () {
        $(this).removeAttr('open').find('summary').removeClass('is-open');
      });
    }
  });
});

jQuery(document).ready(function ($) {
  function initCustomSort(root) {
    var $root = root ? $(root) : $(document);

    $root.find('select[name="sort_by"]').not('[data-ha-sort-ready]').each(function () {
      var $select = $(this);
      $select.attr('data-ha-sort-ready', '1');

      var $wrap = $select.closest('.facet-filters__field .select');
      if (!$wrap.length) $wrap = $select.parent();

      // Build UI
      var $ui = $('<div class="ha_sort"/>');
      var $btn = $('<button type="button" class="ha_sort_btn" aria-haspopup="listbox" aria-expanded="false">SORT</button>');
      var listId = 'ha-sort-' + Math.random().toString(36).slice(2);
      var $list = $('<ul class="ha_sort_list" role="listbox" hidden/>').attr('id', listId);
      var $sortBtn = $('.js_ha_sort');
      function setLabel() {
        $btn.text('SORT');
      }
      setLabel();

      // Mirror options
      $select.find('option').each(function () {
        var $opt = $(this);
        var $li = $('<li class="ha_sort_option" role="option" tabindex="0"></li>')
          .text($opt.text())
          .attr('data-value', $opt.val());

        if ($opt.is(':selected')) $li.addClass('is-active');

        function choose() {
          // Update native select value
          $select.val($opt.val());
          $select.find('option').prop('selected', false);
          $opt.prop('selected', true);

          // Fire native events so Dawn/facets AJAX picks it up
          try {
            $select[0].dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
            $select[0].dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
          } catch (e) {
            var evt1 = document.createEvent('Event'); evt1.initEvent('input', true, true); $select[0].dispatchEvent(evt1);
            var evt2 = document.createEvent('Event'); evt2.initEvent('change', true, true); $select[0].dispatchEvent(evt2);
          }

          // UI sync
          $list.find('.ha_sort_option').removeClass('is-active');
          $li.addClass('is-active');
          setLabel();
          close();
        }

        $li.on('click', choose);
        $li.on('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(); }
          if (e.key === 'Escape') { e.preventDefault(); close(); $btn.trigger('focus'); }
        });

        $list.append($li);
      });

      function open() {
        $list.prop('hidden', false);
        $sortBtn.attr('aria-expanded', 'true');
        ($list.find('.is-active')[0] || $list.children().get(0))?.focus();
      }
      function close() {
        $list.prop('hidden', true);
        $sortBtn.attr('aria-expanded', 'false');
      }

      $sortBtn.on('click', function (e) {
        e.stopPropagation();
        $list.prop('hidden') ? open() : close();
      });
      $sortBtn.on('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      });

      // Click outside
      $(document).on('click.haSort', function (ev) {
        if (!$ui[0].contains(ev.target)) close();
      });

      // Keep label in sync if theme changes select
      $select.on('change.haSort', setLabel);

      // Mount
      $wrap.append($ui);
      $ui.append($list);
    });
  }

  // Initial
  if (document.readyState === 'loading') {
    $(initCustomSort);
  } else {
    initCustomSort();
  }

  // Re-init when Shopify editor loads a section
  document.addEventListener('shopify:section:load', function (e) {
    initCustomSort(e.target || document);
  });

  // Re-init when facets AJAX swaps DOM
  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes && m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('select[name="sort_by"]')) {
          initCustomSort(n.parentElement || document);
        } else if (n.querySelector && n.querySelector('select[name="sort_by"]')) {
          initCustomSort(n);
        }
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Manual hook
  window.haInitSort = initCustomSort;

  // FADEIN IMAGE
  function initFadeInImages() {
    if (!window.gsap) return;

    gsap.utils.toArray(".ha_sake-bar__image--decor img").forEach((img) => {
      gsap.fromTo(img,
        {
          opacity: 0,
          y: 40, // slight move up (optional)
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: img,
            start: "top 80%",
            once: true
          }
        }
      );
    });
  }
  initFadeInImages();

  // PRODUCT SLIDER

  document.querySelectorAll('.ha_swiper__pagination-product').forEach((pagination) => {
    const sliderComponent = pagination.closest('slider-component');
    if (!sliderComponent) return;

    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    const slides = sliderComponent.querySelectorAll('[id^="Slide-"]');
    const bullets = pagination.querySelectorAll('.ha_swiper__bullet');

    if (!slider || !slides.length || !bullets.length) return;

    bullets.forEach((bullet, index) => {
      bullet.addEventListener('click', () => {
        const targetSlide = slides[index];
        if (!targetSlide) return;

        slider.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: 'smooth'
        });
      });
    });

    const updateActiveBullet = () => {
      const sliderLeft = slider.scrollLeft;
      let activeIndex = 0;

      slides.forEach((slide, index) => {
        if (Math.abs(slide.offsetLeft - sliderLeft) < slide.offsetWidth / 2) {
          activeIndex = index;
        }
      });

      bullets.forEach((bullet, index) => {
        bullet.classList.toggle('is-active', index === activeIndex);
      });
    };

    slider.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateActiveBullet);
    });

    updateActiveBullet();
  });

  // GSAP LABEL MENU 
  function initLabelMenuScroll() {
    const section = document.querySelector(".ha_menu");
    if (!section) return;

    const text = section.querySelectorAll(".ha_menu__category span");
    if (!text.length) return;

    gsap.fromTo(
      text,
      { y: 0 },
      {
        y: -20,
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: window.innerWidth < 768 ? "top 85%" : "top center",
          end: window.innerWidth < 768 ? "bottom 15%" : "bottom center",
          scrub: 1,
        }
      }
    );
  }

  initLabelMenuScroll();

  // ACCORDION FOR PRODUCT DETAIL
  document.querySelectorAll('.product__accordion details').forEach((el) => {
    const summary = el.querySelector('summary');
    const content = el.querySelector('.accordion__content');

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      if (el.hasAttribute('open')) {
        // CLOSE
        content.style.height = content.scrollHeight + 'px';

        requestAnimationFrame(() => {
          content.style.height = '0px';
        });

        setTimeout(() => {
          el.removeAttribute('open');
        }, 300);
      } else {
        // OPEN
        el.setAttribute('open', '');
        const height = content.scrollHeight;

        content.style.height = '0px';

        requestAnimationFrame(() => {
          content.style.height = height + 'px';
        });
      }
    });
  });

  // EVENTS DATE MARQUEE
  function initEventsDateMarquee() {
    document.querySelectorAll(".gsap_marquee_slider_date").forEach((marquee) => {
      const inner = marquee.querySelector(".ha_marquee__inner");
      if (!inner) return;

      const items = inner.querySelectorAll(".ha_marquee__item");
      if (!items.length) return;

      // ensure at least 4 items
      if (items.length < 4) {
        const base = inner.innerHTML;
        while (inner.children.length < 4) {
          inner.innerHTML += base;
        }
      }

      // duplicate once for seamless loop
      if (!inner.dataset.clone) {
        inner.innerHTML += inner.innerHTML;
        inner.dataset.clone = "true";
      }

      const width = inner.scrollWidth / 2;

      gsap.killTweensOf(inner);
      gsap.set(inner, { x: 0 });

      gsap.to(inner, {
        x: -width,
        duration: 15,
        ease: "none",
        repeat: -1
      });
    });
  }

  window.addEventListener("load", initEventsDateMarquee);

  // END

});
